<template>
  <div>
    <div style="display: compact;">


      <transition-group name="fade" tag="div" mode="out-in">
        <div v-if="language === 'en'" v-for="(item, index) in blocksEN"  :key="`section__${index}`">
          <content-block
              :id="`section__${index}`"
              :title="item.title"
              :tools="item.tools"
              :date="item.date"
              :is-flex="item.isFlex"
              :content="item.content"
              :images="item.images" />
        </div>
      </transition-group>
      <transition-group name="fade" tag="div" mode="out-in">
        <div v-if="language === 'hu'" v-for="(item, index) in blocksHU"  :key="`section-hu__${index}`">
          <content-block
              :id="`section__${index}`"
              :title="item.title"
              :tools="item.tools"
              :date="item.date"
              :is-flex="item.isFlex"
              :content="item.content"
              :images="item.images" />
        </div>
      </transition-group>

    </div>


  </div>
</template>

<script>
import ContentBlock from "../components/ContentBlock";

export default {
  name: "Home",
  computed: {
    language: function() {
      return this.$store.getters.language;
    }
  },
  components: {
    ContentBlock
  },
  methods:{
    changeCategory(id){
      this.bioCategory = id;
    }
  },
  data: function() {
    return {
      bioCategory: 'contact',
      blocksEN: [
        {
          tools: 'Video installation',
          date: '2024',
          title: 'SELF-HEALING PROCESSES',
          content: `Zsuzsi Simon offen deals with the female body, especially its social perception. To create her work Self- healing Processes, she sought out breast and cervical cancer survivors, who, in the course of in-depth interviews, told her stories about, among other things, the mundane, quotidian activities that helped them get through the most difficult moments of the disease and the treatments. The artist then joined the interview subject in carrying out these activities, and the process was documented on video. Simon’s participation is both  an act of solidarity and respectful compassion, transforming everyday household chores around the home as well as sports into a healing rite for a community of women. Excerpts from almost twenty in-depth interviews are pasted on the backside of the panels that incorporate the videos and make up the installation, which, in addition to their shape reminiscent of female organs, also evoke the banners of the feminist movement, which has brought about important changes, for instance in the way breast cancer is regarded and treated.
`,
          images: [
            { src: require("../assets/img/selfhealing/c_80.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/c_80_1.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/c_802.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/c_803.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/c_804.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/A7404364.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/A7404528.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/A7404562.jpg"), claimed: false },

            { src: require("../assets/img/selfhealing/simon_zsuzsi_c80_A3-01.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/simon_zsuzsi_c80_A3-02.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/simon_zsuzsi_c80_A3-03.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/simon_zsuzsi_c80_A3-04.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/simon_zsuzsi_c80_A3-05.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6719.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6722.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6723.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6726.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6728.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6788.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6802.jpg"), claimed: false },

          ]
        },
      ],
      blocksHU: [
        {
          tools: 'Videóinstalláció, fa, papír, szöveg',
          date: '2024',
          title: "ÖNGYÓGYÍTÓ FOLYAMATOK",
          content: `Ebben a projektben mell- és méhnyakrák túlélőket kerestem meg, akik mélyintejúk során meséltek többek között azokról a profán, hétköznapi cselekvésekről, amelyek segítettek nekik átlendülni a betegség és a kezelések legnehezebb pillanatain. Ezeket a tevékenységeket aztán az interjúalanyaimmal közösen is elvégeztük, a folyamatot pedig videón dokumentáltam. A részvételem kiállás és tiszteletteljes együttérzés is egyben, amely a mindennapi, az otthonhoz, a háztartáshoz kötődő teendőket és a sportot egy női közösség gyógyító rítusává változtatja. A videók mögött a közel húsz mélyinterjú összevonva olvasható, az installációt alkotó táblák pedig amellett, hogy formájukban, női szervekre emlékeztetnek, a feminista transzparenseket is megidézik, amely mozgalom például a mellrák megítélésében és kezelési módjaiban is fontos változásokat ért el.`,
          images: [
            { src: require("../assets/img/selfhealing/c_80.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/c_80_1.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/c_802.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/c_803.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/c_804.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/A7404364.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/A7404528.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/A7404562.jpg"), claimed: false },

            { src: require("../assets/img/selfhealing/simon_zsuzsi_c80_A3-01.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/simon_zsuzsi_c80_A3-02.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/simon_zsuzsi_c80_A3-03.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/simon_zsuzsi_c80_A3-04.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/simon_zsuzsi_c80_A3-05.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6719.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6722.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6723.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6726.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6728.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6788.jpg"), claimed: false },
            { src: require("../assets/img/selfhealing/_DSC6802.jpg"), claimed: false },
          ]
        },
      ]
    };
  }
};
</script>

<style scoped>
.selector p{
  margin-right: 20px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
</style>
